import React from "react";
import ToolMenuIconButton from "../../../../common/ToolMenuIconButton";
import { BsListUl } from "react-icons/bs";

export interface IProps {
  /**
   * ボタンがクリックされた場合に呼び出されます
   */
  onClick?: () => void;
}

class FilesButton extends React.Component<IProps> {
  render(): JSX.Element {
    return (
      <ToolMenuIconButton
        icon={<BsListUl />}
        tooltip="Files"
        onClick={this.props.onClick}
      />
    );
  }
}

/**
 * ファイル一覧ボタン
 */
export default FilesButton;
